export default __webpack_public_path__ + "static/media/articlemenuicon.1b0a2fb6.svg";